<template>
  <b-form @submit.prevent>
    <b-row align-v="center">
      <b-col :cols="!isConsultor ? 12 : 6">
        <b-form-group label="Plano">
          <select-plano
            v-model="modelValue.plano_exitos_id"
            :state="validateState('plano_exitos_id')"
            @isConsultor="handleConsultorChange"
          />
          <b-form-invalid-feedback :state="validateState('plano_exitos_id')">
            Campo obrigatório!
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col v-if="isConsultor" cols="6">
        <b-form-group label="Limite de perfis">
          <b-form-input
            v-model="modelValue.limitacao_perfis"
            placeholder="Ex: 5"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Data da Assinatura">
          <DateInput
            v-model="modelValue.ingresso_at"
            format="dd/MM/yyyy"
            placeholder="Ex. 01/01/2025"
            input-class="form-control bg-transparent"
            :state="validateState('ingresso_at')"
            :date-config="minDateIngressoAt"
          />
          <b-form-invalid-feedback
            class="mt-1"
            :state="validateState('ingresso_at')"
          >
            Campo obrigatório!
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Data de Vencimento">
          <DateInput
            v-model="modelValue.expira_at"
            format="dd/MM/yyyy"
            placeholder="Ex. 01/01/2025"
            input-class="form-control"
            :state="validateState('expira_at')"
            :date-config="minDateExpiraAt"
          />
          <b-form-invalid-feedback :state="validateState('expira_at')">
            A data de vencimento não pode ser menor que a data de assinatura!
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>
<script>
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import cloneDeep from "lodash/cloneDeep";

import SelectPlano from "@/modules/planos/Components/SelectPlano.vue";
import DateInput from "@/components/Form/DateInput.vue";
import { modelValue } from "@/mixins/modelValue";

export default {
  components: { SelectPlano, DateInput },
  mixins: [validationMixin, modelValue("value", "change")],
  props: {
    value: {
      type: Object,
      default: () => ({
        plano_exitos_id: null,
        ingresso_at: null,
        expira_at: null,
      }),
    },
  },
  data() {
    return {
      isConsultor: false,
    };
  },
  computed: {
    minDateIngressoAt() {
      const minDate = moment(this.modelValue.expira_at);
      if (!minDate.isValid()) return { maxDate: null };

      const formatted = minDate.subtract(1, "day").format("YYYY-MM-DD");

      return {
        maxDate: formatted,
      };
    },
    minDateExpiraAt() {
      const minDate = moment(this.modelValue.ingresso_at);
      if (!minDate.isValid()) return { minDate: null };

      const formatted = minDate.add(1, "day").format("YYYY-MM-DD");

      return {
        minDate: formatted,
      };
    },
  },
  validations() {
    return {
      modelValue: {
        plano_exitos_id: { required },
        ingresso_at: { required },
      },
    };
  },
  methods: {
    validateState(name) {
      if (!this.$v.modelValue[name]) return null;

      const { $dirty, $error } = this.$v.modelValue[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.modelValue.$touch();
      const valid = !this.$v.modelValue.$anyError;

      if (!valid) {
        this.$notifications.addNotification({
          message: "Dados inválidos, revise e tente novamente!",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
      return valid;
    },
    handleConsultorChange(isConsultor) {
      this.isConsultor = isConsultor;
    },
    submit() {
      if (!this.isValid()) return;

      this.$emit("submit", cloneDeep(this.modelValue));
    },
  },
};
</script>
